import { Skeleton } from "../Skeleton/Skeleton";

export const OpalRoleSuggestionInstanceEnablementSkeleton = () => {
    return (
        <>
            <Skeleton data-cy="ors-instance-skeleton1" className="push--bottom" height="24px" width="100%" />
            <Skeleton data-cy="ors-instance-skeleton2" className="push--bottom" height="24px" width="100%" />
            <Skeleton data-cy="ors-instance-skeleton3" className="push--bottom" height="24px" width="100%" />
            <Skeleton data-cy="ors-instance-skeleton4" className="push--bottom" height="24px" width="100%" />
            <Skeleton data-cy="ors-instance-skeleton5" className="push--bottom" height="24px" width="100%" />
        </>
    );
};

OpalRoleSuggestionInstanceEnablementSkeleton.displayName = "OpalRoleSuggestionInstanceEnablementSkeleton";
